const {
  resolveSeo,
  buildStructuredData,
  absoluteUrl,
  normalizePathname
} = require("./seoCore.cjs");

function ensureMeta(selector, attributeName, attributeValue) {
  let element = document.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attributeName, attributeValue);
    element.setAttribute("data-seo-managed", "true");
    document.head.appendChild(element);
  }
  return element;
}

function setMetaByName(name, content) {
  const element = ensureMeta(`meta[name="${name}"]`, "name", name);
  element.setAttribute("content", content || "");
}

function setMetaByProperty(property, content) {
  const element = ensureMeta(`meta[property="${property}"]`, "property", property);
  element.setAttribute("content", content || "");
}

function setCanonical(href) {
  let element = document.querySelector('link[rel="canonical"]');
  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", "canonical");
    element.setAttribute("data-seo-managed", "true");
    document.head.appendChild(element);
  }
  element.setAttribute("href", href);
}

function setStructuredData(seo) {
  let element = document.querySelector('script[data-seo-jsonld]');
  if (!element) {
    element = document.createElement("script");
    element.setAttribute("type", "application/ld+json");
    element.setAttribute("data-seo-jsonld", "true");
    document.head.appendChild(element);
  }
  element.textContent = JSON.stringify(buildStructuredData(seo));
}

export function applySeoForRoute(route, overrides = {}) {
  const routePath = route && (route.fullPath || route.path) ? route.fullPath || route.path : "/";
  const seo = resolveSeo(routePath, overrides);

  if (typeof document === "undefined") return seo;

  document.title = seo.title;
  if (document.documentElement) document.documentElement.lang = "zh-CN";

  setMetaByName("description", seo.description);
  setMetaByName("keywords", seo.keywords.join(","));
  setMetaByName("robots", seo.robots);
  setMetaByName("googlebot", seo.robots);
  setMetaByName("bingbot", seo.robots);
  setMetaByName("twitter:card", "summary_large_image");
  setMetaByName("twitter:title", seo.title);
  setMetaByName("twitter:description", seo.description);
  setMetaByName("twitter:image", absoluteUrl(seo.image, "/favicon.ico"));

  setMetaByProperty("og:locale", "zh_CN");
  setMetaByProperty("og:type", seo.ogType);
  setMetaByProperty("og:site_name", "山东尚亚信息科技有限公司");
  setMetaByProperty("og:title", seo.title);
  setMetaByProperty("og:description", seo.description);
  setMetaByProperty("og:url", seo.canonical);
  setMetaByProperty("og:image", absoluteUrl(seo.image, "/favicon.ico"));

  setCanonical(seo.canonical);
  setStructuredData(seo);
  return seo;
}

export function migrateLegacyHashRoute(router) {
  if (typeof window === "undefined" || !router || typeof router.replace !== "function") return "";
  const hash = String(window.location && window.location.hash ? window.location.hash : "");
  if (!/^#\//.test(hash)) return "";
  const pathname = normalizePathname(hash);
  const navigate = () => router.replace(pathname);
  if (typeof router.onReady === "function") {
    router.onReady(navigate);
  } else {
    navigate();
  }
  return pathname;
}

export function installSeo(router) {
  if (!router || typeof router.afterEach !== "function") return;
  migrateLegacyHashRoute(router);
  applySeoForRoute(router.currentRoute || { path: "/", fullPath: "/" });
  router.afterEach(to => applySeoForRoute(to));
}
